import {
   ADD_ORDER_TO_ACTION_LIST,
   CLEAN_ACTION_LIST
} from '../mutation-types';
 
 
const mutations = {
   [ADD_ORDER_TO_ACTION_LIST](state, data) {
      state.action = data
   },

   [CLEAN_ACTION_LIST](state, data) {
     state.action = []
   }
};
 
const state = {
   action: []
};

 const actions = {
   addOrderToActionList({ commit, state }, ids) {
      commit('ADD_ORDER_TO_ACTION_LIST', ids)
   },

   cleanActionList({ commit }) {
     commit('CLEAN_ACTION_LIST')
   }
 }
 
export default {
   state,
   mutations,
   actions
};


// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/action.js